// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"761":"QQShare","857":"WxLaunchHack"}[chunkId] + "." + {"761":"db2a4f6fcc","857":"3d7dbbd151"}[chunkId] + ".js";
};